import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { ApplicationState } from '../../store';
import * as SharedMaterialsManagementStateController from '../../store/StateControllers/SharedMaterials/SharedMaterialsManagementStateController';
import { ToxnotComponentProperties } from '../core/BaseApplicationComponents/ToxnotComponent';
import { ToxnotReactComponentPaths } from '../core/ToxnotReactComponentPaths';
import { ToxnotSignInRequiredComponent } from '../core/BaseApplicationComponents/ToxnotSignInRequiredComponent';

type GrantGroupAccessInputProps =
    typeof SharedMaterialsManagementStateController.actionCreators &
    SharedMaterialsManagementStateController.ManagementState &
    ToxnotComponentProperties &
    RouteComponentProps;

class GrantGroupAccessInput extends ToxnotSignInRequiredComponent<GrantGroupAccessInputProps> {
    // ===============================================================================

    public componentDidMount() {
        this.props.resetGrantingState();
    }

    // ===============================================================================

    protected override getDisallowedRoles() {
        return [];
    }

    // ===============================================================================

    protected renderConcreteComponent() {
        // Handle page refresh on this component. 
        if (Object.keys(this.props.accessManagerState.currentlySelectedSharedMaterialIds).length === 0 &&
            !this.props.accessManagerState.currentlyShowACLForSharedMaterialId) {
            this.props.history.push(ToxnotReactComponentPaths.MyPassports);

            // Must return here, else React will try to render this component, before navigating to the Access Manager.
            return null;
        }

        return (
            <div className="tn-section">
                <div className="tn-section-row tn-section-heading-row">
                    <div className="tn-section-col-12">
                        <h1>{this.localizeString("Grant Access to Team")}</h1>
                    </div>
                </div>
                <div className="tn-section-row">
                    <div className="tn-section-col-12">
                        {this.props.accessManagerState.grantingState === SharedMaterialsManagementStateController.ManagementOperationBaseStates.Default && <div className="alert alert-info">{this.localizeString("Note: Email Addreses that are given access will also grant access to the team that email is associated with.")}</div>}
                    </div>
                </div>
                <div className="tn-section-row">
                    <div className="tn-section-col-12">
                        {this.props.accessManagerState.grantingState === SharedMaterialsManagementStateController.ManagementOperationBaseStates.OperationStarted && <div className="alert alert-info">{this.localizeString("Granting...")}</div>}
                        {this.props.accessManagerState.grantingState === SharedMaterialsManagementStateController.ManagementOperationBaseStates.OperationCompleted && <div className="alert alert-success">{this.localizeString("Successfully Granted Access!")}</div>}
                        {this.props.accessManagerState.grantingState === SharedMaterialsManagementStateController.ManagementOperationBaseStates.OperationFailed && <div className="alert alert-danger">{this.localizeString("Sorry, there was a problem granting access.")}</div>}
                        <div className="grouped-data">
                            <div className="group">
                                <div className="title">{this.localizeString("Enter emails to grant access")}</div>
                                <div className="content">
                                    {this.renderListedMaterialSection(Object.keys(this.props.accessManagerState.currentlySelectedSharedMaterialIds))}
                                    <input type="text" id="email-addresses-input" className="form-control" placeholder={this.localizeString("Comma separated Email addresses. The entire team of the email address entered will be added")} />
                                </div>
                            </div>
                            {this.props.accessManagerState.grantingState !== SharedMaterialsManagementStateController.ManagementOperationBaseStates.OperationCompleted && <button onClick={e => this.grantGroupAccessButton_click()} className="btn btn-toxnot-primary">{this.localizeString("Grant Access")}</button>}
                            {this.props.accessManagerState.grantingState === SharedMaterialsManagementStateController.ManagementOperationBaseStates.OperationCompleted && <a href={ToxnotReactComponentPaths.MyPassports} className="btn btn-toxnot-primary">{this.localizeString("Done")}</a>}
                            {" "}
                            <button onClick={e => this.cancelButton_click()} className="btn btn-default">{this.localizeString("Cancel")}</button>
                        </div>
                    </div>
                </div>
            </div>
        )   
    }

    // ===============================================================================

    private renderListedMaterialSection(sharedMaterialIds: string[]) {
        return (
            <div className="granting-access-materials-list">
                <ul>
                    {sharedMaterialIds.map((id, index) => (<li key={index}>{this.props.ownedSharedMaterialsMap[id].materialName}</li>))}
                </ul>
            </div>
        )
    }

    // ===============================================================================
    //
    // UI Event Handlers
    //
    // ===============================================================================

    private grantGroupAccessButton_click = () => {
        const emailAddressesAsString = $("#email-addresses-input").val()?.toString().trim() ?? "";

        const emailAddressesAsList = emailAddressesAsString.split(",").map(e => e.trim()).filter(s => s.length > 0);

        if (emailAddressesAsList.length === 0) {
            alert(this.localizeString("You must provide at least one email address in order to grant access."));
            return;
        }
      
        this.props.grantGroupAccessToSharedMaterials(emailAddressesAsList, Object.keys(this.props.accessManagerState.currentlySelectedSharedMaterialIds));
    }

    // ===============================================================================

    private cancelButton_click = () => {
        this.props.updateSelectedMaterials({});
        this.props.history.goBack()
    }
}

export default connect(
    (state: ApplicationState) => ({ ...state.sharedMaterialsManagementState, appServices: state.appServices }),
    SharedMaterialsManagementStateController.actionCreators // Selects which action creators are merged into the component's props
)(GrantGroupAccessInput as any);